import CruiseDeal1 from '../assets/singapore.avif';
import CruiseDeal2 from '../assets/Vibrant Caribbean _.jpg';
import CruiseDeal3 from '../assets/europe2.jpg' ;


const CruiseDealdata = [
    {
      img: CruiseDeal1,
      Destination:  "Picturesque Singapore" ,
      Offer : "Get 60% OFF On Second Guest + Kids Cruise FREE",
      Ship : "Ovation of the Seas Valid till 31st May 2025",
      link :"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&Ship=13717&DeparturePorts=SIN&sortColumn=departureDate&sortOrder=asc"
    },
    {
        img: CruiseDeal2,
        Destination:  "Vibrant Caribbean" ,
        Offer : "Get 60% OFF On Second Guest + Kids Cruise FREE",
        Ship : "Star of the Seas Valid till 31st May 2025",
        link : "https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&Ship=15330&sortColumn=cruiselinePriority&sortOrder=asc"

    },
    {
        img: CruiseDeal3,
        Destination:  "Europe" ,
        Offer : "Get 60% OFF On Second Guest + Kids Cruise FREE",
        Ship : "Legend of the Seas, Allure of the Seas, Odyssey of the Seas,  Valid till 31st May 2025",
        link : "https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=departureDate&sortOrder=asc"

    }
]

export default CruiseDealdata ;